import { render, staticRenderFns } from "./EcommerceDeliveryCharge.vue?vue&type=template&id=6ff454fa&"
import script from "./EcommerceDeliveryCharge.vue?vue&type=script&lang=js&"
export * from "./EcommerceDeliveryCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports